import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

import { FormBuilderContextMenuItemBase } from './fb-context-menu-base';
import { FormBuilderComponent } from '../../../components/form-builder/form-builder.component';
import { Form } from '../form.model';
//import { CopyFormDialog } from '../../dialogs/copy-form/copy-form.dialog';
//import { ExportStructureInstancesDialog } from '../../dialogs/export-structure/export-structure.dialog';
//import { XmlFileFormatEnum } from '../../enums/xml-file-format.enum';
//import { DisplayContentData, DisplayContentDialog, DisplayContentDialogInitData } from '../../dialogs/display-content/display-content.dialog';
import { TrashDeleteEvent } from '../../../components/list-view/list-view-trash-config.model';
import { IListItem } from '../../../interfaces/ilist-item.interface';
import { LayoutRow } from '../layout-row.model'
import { ContextMenuItemDivider } from '../../menu/context-menu-item-base';

// Define menu classes.
export class MoveRowUpContextMenuData extends FormBuilderContextMenuItemBase {
    public constructor(itemTitle: string, component: FormBuilderComponent) {
        super(itemTitle, component);
    }

    public get MenuItemDisabled(): boolean {
        let row: LayoutRow = this.contextItem;
        return ((row == null) || (row.position == 1));
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        let row: LayoutRow = contextItem;
        this.component.moveRowClick(row, -1);
    }
}

export class MoveRowDownContextMenuData extends FormBuilderContextMenuItemBase {
    public constructor(itemTitle: string, component: FormBuilderComponent) {
        super(itemTitle, component);
    }

    public get MenuItemDisabled(): boolean {
        let row: LayoutRow = this.contextItem;
        return ((row == null) || row.isLastRow);
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        let row: LayoutRow = contextItem;
        this.component.moveRowClick(row, +1);
    }
}

export class InsertRowAboveContextMenuData extends FormBuilderContextMenuItemBase {
    public constructor(itemTitle: string, component: FormBuilderComponent) {
        super(itemTitle, component);
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        let row: LayoutRow = this.contextItem;
        this.component.insertRowClick(row.position - 1)
    }
}

export class InsertRowBelowContextMenuData extends FormBuilderContextMenuItemBase {
    public constructor(itemTitle: string, component: FormBuilderComponent) {
        super(itemTitle, component);
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        let row: LayoutRow = this.contextItem;
        this.component.insertRowClick(row.position);
    }
}

export class CellOperationsRowMenuDivider extends FormBuilderContextMenuItemBase {
    public constructor(component: FormBuilderComponent) {
        super(null, component);
    }

    public get IsMenuDivider(): boolean {
        return true;
    }

    public get DisplayMenuItem(): boolean {
        return this.component.ShowCellSelectionCheckboxes;
    }
}

export class MergeRowCellsContextMenuData extends FormBuilderContextMenuItemBase {
    public constructor(itemTitle: string, component: FormBuilderComponent) {
        super(itemTitle, component);
    }

    public get DisplayMenuItem(): boolean {
        return this.component.ShowCellSelectionCheckboxes;
    }

    public get MenuItemDisabled(): boolean {
        let row: LayoutRow = this.contextItem;
        return ((row == null) || (!this.component.ShowCellSelectionCheckboxes) || this.component.MergeCellsDisabledFor(row));
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        let row: LayoutRow = this.contextItem;
        this.component.mergeRowCellsClick(row);
    }
}

export class SeparateRowCellsContextMenuData extends FormBuilderContextMenuItemBase {
    public constructor(itemTitle: string, component: FormBuilderComponent) {
        super(itemTitle, component);
    }

    public get DisplayMenuItem(): boolean {
        return this.component.ShowCellSelectionCheckboxes;
    }

    public get MenuItemDisabled(): boolean {
        let row: LayoutRow = this.contextItem;
        return ((row == null) || (!this.component.ShowCellSelectionCheckboxes) || this.component.SeparateCellsDisabledFor(row));
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        let row: LayoutRow = this.contextItem;
        this.component.separateRowCellsClick(row);
    }
}

export class DeleteRowContextMenuData extends FormBuilderContextMenuItemBase {
    public constructor(itemTitle: string, component: FormBuilderComponent) {
        super(itemTitle, component);
    }

    public get MenuItemDisabled(): boolean {
        let row: LayoutRow = this.contextItem;
        return ((row == null) || row.isLastRow);
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        let row: LayoutRow = contextItem;
        this.component.deleteRow(row);
    }
}

export class DeleteBlankRowsContextMenuData extends FormBuilderContextMenuItemBase {
    public constructor(itemTitle: string, component: FormBuilderComponent) {
        super(itemTitle, component);
    }

    public get MenuItemDisabled(): boolean {
        let form: Form = this.component.form;
        let disable: boolean = !form.formLayout.hasBlankRows;
        return disable;
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        this.component.deleteBlankRows();
    }
}
